import util from '@/libs/util.ice'; // 菜单配置

// 菜单 顶栏
const headerMenuConfig = []

export default util.recursiveMenuConfig(headerMenuConfig); // 导出侧边栏菜单